import { render, staticRenderFns } from "./PersonalCenter.vue?vue&type=template&id=f6a30c84&scoped=true"
import script from "./PersonalCenter.vue?vue&type=script&lang=js"
export * from "./PersonalCenter.vue?vue&type=script&lang=js"
import style0 from "./PersonalCenter.vue?vue&type=style&index=0&id=f6a30c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a30c84",
  null
  
)

export default component.exports